import { Plus, Trash, ChatCircleDots } from "@phosphor-icons/react";
import { formatDate } from "../../lib/format";

export default function SessionList({ sessions, activeId, onSelect, onNew, onDelete }) {
  return (
    <div className="bg-white border border-slate-200 rounded shadow-sm flex flex-col h-full" data-testid="ai-session-list">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-slate-500">Percakapan</div>
        <button
          onClick={onNew}
          className="inline-flex items-center gap-1 text-xs font-bold text-white bg-violet-600 hover:bg-violet-700 px-2.5 py-1.5 rounded"
          data-testid="ai-new-session"
        >
          <Plus size={12} weight="bold" /> Baru
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        {sessions.length === 0 ? (
          <div className="p-4 text-xs text-slate-500">Belum ada percakapan.</div>
        ) : (
          sessions.map((s) => (
            <div
              key={s.id}
              onClick={() => onSelect(s.id)}
              className={`px-4 py-3 border-b border-slate-100 cursor-pointer group flex items-start gap-2 transition-colors ${
                s.id === activeId ? "bg-violet-50 border-l-2 border-l-violet-600" : "hover:bg-slate-50"
              }`}
              data-testid={`ai-session-${s.id}`}
            >
              <ChatCircleDots size={16} weight="duotone" className="text-violet-600 mt-0.5 shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-slate-900 truncate">{s.title}</div>
                <div className="text-[11px] text-slate-500">
                  {formatDate(s.updated_at).split(",")[0]} · {s.message_count || 0} pesan
                </div>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(s);
                }}
                className="opacity-0 group-hover:opacity-100 text-slate-400 hover:text-red-600 p-1 transition-opacity"
                title="Hapus percakapan"
                data-testid={`ai-session-delete-${s.id}`}
              >
                <Trash size={14} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
